/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MCQOptionCreate } from './mCQOptionCreate';
import type { MCQQuestionCreateExplanation } from './mCQQuestionCreateExplanation';
import type { MCQQuestionCreateDifficulty } from './mCQQuestionCreateDifficulty';
import type { MCQQuestionCreateImageUrl } from './mCQQuestionCreateImageUrl';
import type { MCQQuestionCreateImageAlt } from './mCQQuestionCreateImageAlt';

/**
 * Request to create an MCQ question (without server-generated fields).
 */
export interface MCQQuestionCreate {
  text: string;
  /**
   * Must have at least 2 options
   * @minItems 2
   */
  options: MCQOptionCreate[];
  explanation?: MCQQuestionCreateExplanation;
  difficulty?: MCQQuestionCreateDifficulty;
  imageUrl?: MCQQuestionCreateImageUrl;
  imageAlt?: MCQQuestionCreateImageAlt;
}
